import { useEffect, useState } from "react";
import useAxios from "../../../../hooks/useAxios";
import Constants from "../../../../Constants";
import { getDashboardFilterQueryString } from "../../../../utils/helper";
import { useCompanyFilterContext } from "../../components/context/CompanyFilterContext";

// Generic single-distribution fetch plus normalized open/close state for the shared histogram modal
export const useCaseDistribution = ({ endpointKey, valuesKey }) => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange } = filterParams;
    const { getData } = useAxios();

    const [distribution, setDistribution] = useState([]);
    const [selectedDistribution, setSelectedDistribution] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const fetchDistribution = async () => {
            const baseUrl = Constants.ApiUrl.super.dashboard;
            const query = getDashboardFilterQueryString({ selectedRange });

            try {
                const response = await getData(`${baseUrl[endpointKey]}?${query}`);
                if (response?.success) {
                    const items = response?.data?.items || [];
                    // Expose the raw values under a common key so the shared modal stays generic
                    setDistribution(items.map((item) => ({ ...item, values: item[valuesKey] })));
                }
            } catch (err) {
                console.error(`Failed to fetch ${endpointKey} distribution`, err);
                setDistribution([]);
            }
        };

        fetchDistribution();
    }, [selectedRange]);

    const onOpen = ({ row, metricLabel, summary }) => {
        setSelectedDistribution({ ...row, metricLabel, summary });
        setIsOpen(true);
    };

    const close = () => {
        setIsOpen(false);
    };

    return { distribution, selectedDistribution, isOpen, onOpen, close };
};
